import { jsx } from "react/jsx-runtime";
import { merge } from "lodash";
import { useMemo } from "react";
import { defaultTheme } from "../theme.js";
import { StyleSheetManager, ThemeProvider } from "styled-components";
const getIndexColumnWidth = (width, rowCount) => {
  const excessCharCount = ((rowCount == null ? void 0 : rowCount.toString().length) ?? 0) - 4;
  if (excessCharCount > 0) {
    const additionalWidth = 6 * excessCharCount;
    return width + additionalWidth;
  }
  return width;
};
const CompleteThemeProvider = ({
  theme,
  rowCount,
  ...props
}) => {
  const completeTheme = useMemo(() => {
    const combinedTheme = merge(defaultTheme, theme ?? {});
    const indexColumnWidth = getIndexColumnWidth(
      combinedTheme.indexColumn.width,
      rowCount
    );
    return {
      ...combinedTheme,
      indexColumn: {
        ...combinedTheme.indexColumn,
        width: indexColumnWidth
      }
    };
  }, [theme, rowCount]);
  return /* @__PURE__ */ jsx(
    StyleSheetManager,
    {
      disableVendorPrefixes: process.env.NODE_ENV !== "production",
      children: /* @__PURE__ */ jsx(ThemeProvider, { theme: completeTheme, ...props })
    }
  );
};
export {
  CompleteThemeProvider
};
